var $ = require("jquery");

$(function() {
    if (!sessionStorage.getItem('ageModal')) {
        sessionStorage.setItem('ageModal', 1);
        $('#ageModal').modal('show');
    } else {
        $('#ageModal').modal('hide');
    }
    $("#underAge").on("click", function() {
        sessionStorage.setItem('ageModal', 0);
    });
});
